import { FC } from "react";

type ActionAreasProps = {
  home: number;
  middle: number;
  away: number;
};

export const ActionAreas: FC<ActionAreasProps> = ({ home, middle, away }) => {
  const maxArea = Math.max(home, middle, away);

  const AreaCard: FC<{
    value: number;
    highlight: boolean;
    children?: React.ReactNode;
  }> = ({ value, highlight, children }) => (
    <div
      className="relative flex flex-1 items-center justify-center text-[3vw] font-bold text-white"
      style={{
        background: highlight ? "rgba(128,128,128,0.35)" : "transparent",
      }}
    >
      <span className="absolute z-10">{value.toFixed(1)}%</span>
      {children}
    </div>
  );

  return (
    <div className="flex w-full flex-col items-center">
      <span className="mb-2 text-[2.5vw] font-bold text-statisticTitle">
        Action Areas
      </span>
      <div className="flex h-[10vw] w-full border border-border">
        <AreaCard value={home} highlight={home === maxArea}>
          <span className="absolute left-0 h-[2vw] w-[1vw] border border-border border-l-0" />
          <span className="absolute left-0 h-[4vw] w-[2vw] border border-border border-l-0" />
        </AreaCard>
        <AreaCard value={middle} highlight={middle === maxArea}>
          <span className="absolute h-[7vw] w-[7vw] rounded-full border border-border" />
          <span className="absolute h-full border-l border-border" />
        </AreaCard>
        <AreaCard value={away} highlight={away === maxArea}>
          <span className="absolute right-0 h-[2vw] w-[1vw] border border-border border-r-0" />
          <span className="absolute right-0 h-[4vw] w-[2vw] border border-border border-r-0" />
        </AreaCard>
      </div>
    </div>
  );
};
